import axios from "axios";

export const fetchAllUserInvoiceInformations = async () => {
  try {
    const response = await axios.get(
      "/api/InvoiceInformation/GetAllInvoiceInformations"
    );
    const userInvoiceInformations = response.data.Payload;
    return userInvoiceInformations;
  } catch (error) {
    console.error(error);
  }
};
// POST /api/subscription/123/create-renewal-order

export const createRenewalOrder = async (subscriptionId) => {
  try {
    const response = await axios.post(
      `/api/Subscription/${subscriptionId}/create-renewal-order`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const updateUserInvoiceInformation = async (invoiceInformation) => {
  try {
    const response = await axios.put(
      "/api/InvoiceInformation/UpdateInvoiceInformation",
      invoiceInformation
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteUserInvoiceInformation = async (invoiceInformationId) => {
  try {
    const response = await axios.delete(
      `/api/InvoiceInformation/DeleteInvoiceInformation/${invoiceInformationId}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const addUserInvoiceInformation = async (invoiceInformation) => {
  try {
    const response = await axios.post(
      "/api/InvoiceInformation/AddInvoiceInformation",
      invoiceInformation
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getCities = async () => {
  try {
    const response = await axios.get("/api/InvoiceInformation/GetAllCities");

    const cities = response.data.Payload;
    return cities;
  } catch (error) {
    console.error(error);
  }
};

export const getCityCounties = async (cityId) => {
  try {
    const response = await axios.get(
      "/api/InvoiceInformation/GetCityCounties",
      {
        params: {
          cityId: cityId,
        },
      }
    );
    const counties = response.data.Payload;
    return counties;
  } catch (error) {
    console.error(error);
  }
};

export const getTaxOffices = async () => {
  try {
    const response = await axios.get(
      "/api/InvoiceInformation/GetAllTaxOffices"
    );
    const taxOffices = response.data.Payload;
    return taxOffices;
  } catch (error) {
    console.error(error);
  }
};

export const createOrder = async (CreateOrderDTO) => {
  try {
    const response = await axios.post("/api/Order/CreateOrder", CreateOrderDTO);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getOrderById = async (orderId) => {
  try {
    const response = await axios.get(`/api/Order/GetOrderById/${orderId}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUserSubscriptions = async () => {
  try {
    const response = await axios.post("/api/User/GetUserSubscriptions");
    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};

export const updateUserProfile = async (profileData) => {
  try {
    const response = await axios.put(
      "/api/User/UpdateUserProfile",
      profileData
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUserInvoices = async () => {
  try {
    const response = await axios.get("/api/InvoiceInformation/GetUserInvoices");

    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};

export const getPanelStatus = async (subscriptionId) => {
  try {
    const response = await axios.get("/api/User/GetPanelStatus", {
      //
      params: {
        subscriptionId: subscriptionId,
      },
    });

    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};

export const getGetFirstUserStatus = async (subscriptionId) => {
  try {
    const response = await axios.get("/api/User/GetFirstUserStatus", {
      params: {
        subscriptionId: subscriptionId,
      },
    });

    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};

export const createPanelFirstUser = async (subscriptionId) => {
  try {
    const response = await axios.get("/api/User/CreatePanelFirstUser", {
      params: {
        subscriptionId: subscriptionId,
      },
    });
    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};

export const sendEmailWithCredentials = async (
  selectedSubscriptionId,
  userName,
  Password
) => {
  try {
    const response = await axios.post("/api/User/SendEmailWithCredentials", {
      username: userName,
      subscriptionId: selectedSubscriptionId,
      password: Password,
    });
    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};
